module.exports = __webpack_public_path__ + "2994b993094c8bf08097b82cd293cc63.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W11.jpg
// module id = 3491
// module chunks = 0